module.exports = __webpack_public_path__ + "img/logo.f5c650f2.png";